import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Assessment, AssessmentSequence, UserAssessment } from './_types';
import { AssessmentSequenceListItem } from './assessment';

export const normalizeAssessment = (assessment: any): Assessment => {
  const normalizedAssessment = camelcaseKeys(assessment, { deep: true });

  // Ensure fields are properly normalized
  normalizedAssessment.fields = (normalizedAssessment?.fields || []).map(
    (field: any) => {
      // Keep the 'type' property as is (don't camelCase it)
      const { type } = field;
      const normalizedField = camelcaseKeys(field, { deep: true });
      normalizedField.type = type;
      return normalizedField;
    }
  );

  return normalizedAssessment as Assessment;
};

export const normalizeAssessmentSequence = (
  assessmentSequence: any
): AssessmentSequence => {
  const normalizedAssessmentSequence = camelcaseKeys(assessmentSequence, {
    deep: true,
  });

  // Ensure groupingItems are properly normalized
  normalizedAssessmentSequence.groupingItems =
    normalizedAssessmentSequence.groupingItems.map((item: any) => {
      const { groupableType } = item;
      const normalizedItem = camelcaseKeys(item, { deep: true });
      normalizedItem.groupableType = groupableType;
      return normalizedItem;
    });

  return normalizedAssessmentSequence;
};

export const normalizeUserAssessment = (assessment: any): UserAssessment => {
  const normalizedAssessment = camelcaseKeys(assessment, { deep: true });

  // Ensure results are properly normalized
  normalizedAssessment.results = normalizedAssessment.results.map(
    (result: any) => {
      const { type } = result;
      const normalizedResult = camelcaseKeys(result, { deep: true });
      normalizedResult.type = type; // Keep the 'type' property as is
      return normalizedResult;
    }
  );

  return normalizedAssessment as UserAssessment;
};

export const normalizeAssessmentSequenceList = (
  assessmentSequenceList: any
): AssessmentSequenceListItem => {
  return {
    id: assessmentSequenceList['groupings.id'],
    name: assessmentSequenceList['groupings.name'],
  };
};
